module.exports = {"Save":"Speichern","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Tippen zum Suchen (* für alle)","shipment.packagingSender":"Sender","Supplier":"Anbieter"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/de.json
// module id = 1351
// module chunks = 1